export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-8">关于喵趣</h2>
          <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/80">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-10 flex items-center justify-center">
                <i className="ri-emotion-happy-line text-2xl text-primary-500"></i>
              </span>
              <span className="font-heading text-xl text-foreground-900">喵趣漫画网</span>
            </div>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                喵趣漫画网诞生于对漫画的热爱。我们深知每一位漫画读者在寻找优质内容时的期待与焦虑——
                担心追更不及时、苦恼翻页体验差、害怕遇到付费墙。正因如此，我们打造了这样一个平台：
                汇集韩漫、日漫、国漫的免费全集资源，采用创新的下拉式阅读方式，让漫画阅读回归纯粹与畅快。
              </p>
              <p>
                我们的内容团队每日追踪海内外最新漫画动态，与多家汉化组和原创平台保持紧密合作，
                确保热门连载第一时间同步更新。从韩国webtoon的人气恋爱番，到日本经典的少年热血篇，
                再到国产古风玄幻的崛起之作，喵趣漫画致力于成为漫画爱好者最信赖的一站式阅读家园。
              </p>
              <p>
                下拉式阅读是我们的核心体验升级——告别传统翻页的断续感，让纵向滑动成为最自然的阅读节奏。
                无论你是在通勤路上、午休间隙还是深夜放松，打开喵趣漫画，下滑之间，故事即在指尖流淌。
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-4">
              <div className="flex items-center gap-2 text-sm">
                <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-primary-600 text-xs"></i>
                </span>
                <span className="text-foreground-700">正版授权合作</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-team-line text-accent-600 text-xs"></i>
                </span>
                <span className="text-foreground-700">专业汉化团队</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-eye-line text-secondary-600 text-xs"></i>
                </span>
                <span className="text-foreground-700">百万日活读者</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}